import React, { useEffect, useState } from 'react';
import './Countdown.css';

/* Live countdown: days · hours · minutes · seconds until `to` (an ISO date).
   Used on the student dashboard and the Competitions page. */
const split = (ms) => {
  const t = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
};
const pad = (n) => String(n).padStart(2, '0');

const Countdown = ({ to, label, size = 'md', onDone }) => {
  const target = new Date(to).getTime();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!target || Number.isNaN(target)) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  const left = target - now;
  useEffect(() => {
    if (left <= 0 && onDone) onDone();
  }, [left <= 0]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!target || Number.isNaN(target)) return null;
  const { d, h, m, s } = split(left);
  const parts = [
    [d, d === 1 ? 'day' : 'days'],
    [pad(h), 'hours'],
    [pad(m), 'min'],
    [pad(s), 'sec'],
  ];

  return (
    <div className={`rmcd rmcd--${size} ${left < 86400000 ? 'is-soon' : ''}`} role="timer" aria-label={`${label || 'Time left'}: ${d} days ${h} hours ${m} minutes`}>
      {label && <span className="rmcd-label">{label}</span>}
      <div className="rmcd-boxes" aria-hidden="true">
        {parts.map(([v, unit]) => (
          <span key={unit} className="rmcd-box">
            <b>{v}</b>
            <small>{unit}</small>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
